export default __webpack_public_path__ + "static/sensai-quote-banner-ac03f9dabd665dece90afa6479c05cab.png";